<template>
  <div class="content">
    <div class="container-tools">
      <div class="item-tools" @click="newItem(2)"><img title="Punto" src="../../../assets/icon-marker.png"/></div>
      <div class="item-tools" @click="newItem(3)"><img title="Linea" src="../../../assets/icon-line.png"/></div>
      <div class="item-tools" @click="newItem(1)"><img title="Area" src="../../../assets/icon-area.png"/></div>
      <div v-b-tooltip="{ title: 'Solo archivos .csv, con el nombre de las columnas (latitud y longitud)', placement: 'bottom' }" class="item-tools" style="position:relative !important;">
        <img src="../../../assets/icon-upload-csv.png" title="Importar CSV">
        <input class="item-tools-upload" accept=".csv" type="file" @change="loadCSV"/>
      </div>
      <div v-b-tooltip="{ title: 'Solo archivos .kml, con menos de 1000 vertices', placement: 'bottom' }" class="item-tools" style="position:relative !important;">
        <img src="../../../assets/icon-upload-kml.png" title="Importar KML">
        <input class="item-tools-upload" accept=".kml" type="file" @change="loadKML"/>
      </div>
      <div v-b-tooltip="{ title: 'Solo archivos .zip, con los archivos .shp y con menos de 1000 vertices', placement: 'bottom' }" class="item-tools" style="position:relative !important;">
        <img src="../../../assets/icon-upload-shp.png" title="Importar Shapefile">
        <input class="item-tools-upload" accept=".zip" type="file" @change="loadSHP"/>
      </div>
      <div v-b-tooltip="{ title: 'Permite exportar la cobertura en archivo .kml', placement: 'bottom' }" class="item-tools" style="position:relative !important;" @click="exportKmlFile">
        <img src="../../../assets/icon-download-kml.png" title="Exportar KML">
      </div>
    </div>
    <hr style="height: .5px; background-color: #D8DBDB; width: 100%; margin: 0px !important;">
    <div class="container-button-confirm">
      <button @click="removeItemChecked" class="button is-link">Eliminar seleccinados</button>
      <button @click="backToMappingList" class="button is-danger">Cancelar</button>
      <button @click="showDialogSave" class="button is-primary">Guardar</button>
    </div>
    <hr style="height: .5px; background-color: #D8DBDB; width: 100%; margin: 0px !important;">
    <div class="content-title">Listado de coberturas</div>
    <hr style="height: .5px; background-color: #D8DBDB; width: 100%; margin: 0px !important;">
    <div class="container-list-shape">
      <template v-if="mappingDetails.length > 0 ">
        <ul class="no-bullets">
          <template v-for="(item, index) in mappingDetails">
            <li :id="`item-mapping-detail-${item.id}`">
              <div class="item-mapping-detail">
                <p style="width: 100%; margin: auto;">{{ getFigureType(item) }}</p>
                <span @click="zoomInItem(item)"><i class="fas fa-search"></i></span>
                <span @click="setVisibility(item)" style="margin-left: 5px; margin-right: 5px;"><i class="fas fa-eye"
                                                                                                   :id="`item-mapping-detail-visibility-${item.id}`"></i></span>
                <span @click="removeItem(item)"><i class="fas fa-trash"></i></span>
              </div>
              <div class="item-mapping-detail-text">
                <div><input :id="`item-mapping-detail-check-${item.id}`" class="checkbox_item" type="checkbox" @click="selectItem(item)"></div>
                <div class="item-mapping-detail-text-style" @click="selectItem(item)">
                  <template v-if="item.idc_figura === 1">
                    <div class="item-text">Perímetro: {{ calculatePerimeter(item) }} km.</div>
                    <div class="item-text">Área: {{ calculateArea(item) }} ha.</div>
                  </template>
                  <template v-else-if="item.idc_figura === 2">
                    <div class="item-text">UTM:
                      {{ formatUTM(item.lstMapeo_puntos[0].latitud, item.lstMapeo_puntos[0].longitud) }}
                    </div>
                    <div class="item-text">Latitude: {{ item.lstMapeo_puntos[0].latitud }}</div>
                    <div class="item-text">Longitude: {{ item.lstMapeo_puntos[0].longitud }}</div>
                  </template>
                  <template v-else-if="item.idc_figura === 3">
                    <div class="item-text">Perímetro: {{ calculatePerimeter(item) }} km.</div>
                  </template>
                </div>
              </div>
            </li>
            <hr style="height: .5px; background-color: #D8DBDB; width: 100%; margin: 0px !important;">
          </template>
        </ul>
      </template>
      <template v-else>
        <div><span class="content-title">Sin Coberturas</span></div>
      </template>
    </div>
    <DialogMappingABM v-show="showModalDialogMappingABM"
                      v-bind:name="name"
                      v-bind:description="description"
                      @close="showModalDialogMappingABM = false"
                      @accept="saveMappping"
                      class="dialog-mapping-abm"/>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import device from "vue-device-detector"
import {LatLon} from "@/plugins/utm/utm";
import {config} from '@/config.json'
import {v4 as uuidv4} from 'uuid';
import * as Utils from '@/helpers/utils'
import * as LocalStorage from "@/helpers/localstorage";
import DialogMappingABM from "@/components/main/dialog/DialogMappingABM";
import {computeArea, LatLng} from "spherical-geometry-js";

Vue.use(device);

export default {
  name: "CoberturaAdd",
  components: {
    DialogMappingABM
  },
  data() {
    return {
      tools: [
        {"name": "Punto", "icon": '../../../assets/icon-marker.png', "isInput": false},
        {"name": "Linea", "icon": '../../../assets/icon-line.png', "isInput": false},
        {"name": "Area", "icon": '../../../assets/icon-area.png', "isInput": false},
        {"name": "ImportCSV", "icon": '../../../assets/icon-upload-csv.png', "isInput": true},
        {"name": "ImportKML", "icon": '../../../assets/icon-upload-kml.png', "isInput": true},
        {"name": "Shapefile", "icon": '../../../assets/icon-upload-shp.png', "isInput": true},
        {"name": "ExportKML", "icon": '../../../assets/icon-download-kml.png', "isInput": false},
      ],

      mapping: undefined,
      mappingDetails: [],
      mappingDetailsForDelete: [],

      name: "",
      description: "",
      showModalDialogMappingABM: false,
    }
  },
  methods: {
    loadData(mapping) {
      const self = this;
      self.mapping = mapping.mapping;
      if (self.mapping == undefined) {
        //cuando no haya datos limpiar
        return;
      }
      self.name = mapping.nombre;
      self.description = mapping.descripcion;
      self.mappingDetails = self.mapping.lstMapeo_detalles;
      self.mappingDetails.forEach((item) => {
        switch (item.idc_figura) {
            //area
          case 1: {
            self.$root.$emit("map-draw-area", item);
            break;
          }
            //point
          case 2: {
            self.$root.$emit("map-draw-point", item);
            break;
          }
            //line
          case 3: {
            self.$root.$emit("map-draw-line", item);
            break;
          }
            //gps
          case 4: {
            break;
          }
        }
      });
    },
    getFigureType(item) {
      switch (item.idc_figura) {
        case 1: {
          return "Area"
        }
        case 2: {
          return "Punto"
        }
        case 3: {
          return "Linea"
        }
        case 4: {
          break;
        }
      }
    },
    formatUTM(lat, lng) {
      return new LatLon(lat, lng).toUtm().toString();
    },
    calculatePerimeter(item) {
      let path = item.lstMapeo_puntos.map(elem => ({lat: elem.latitud, lng: elem.longitud}));
      let total = 0;
      for (let i = 0; i < path.length - 1; i++) {
        let pos1 = new google.maps.LatLng(path[i].lat, path[i].lng);
        let pos2 = new google.maps.LatLng(path[i + 1].lat, path[i + 1].lng);
        total += google.maps.geometry.spherical.computeDistanceBetween(pos1, pos2);
      }
      return (total/1000).toFixed(2);
    },
    calculateArea(item) {
      let path = item.lstMapeo_puntos.map(elem => ({lat: elem.latitud, lng: elem.longitud}));
      let latLngs = path.map(function(coord) {
        return new LatLng(coord.lat, coord.lng);
      });

      return (computeArea(latLngs)/10000).toFixed(2);
    },
    zoomInItem(item) {
      console.log(item)
      this.$root.$emit('map-zoom-mapping', item);
    },
    setVisibility(item) {
      let icon = document.querySelector(`#item-mapping-detail-visibility-${item.id}`);
      if (icon.classList.contains("fa-eye")) {
        icon.classList.remove("fa-eye");
        icon.classList.add("fa-eye-slash");
      } else {
        icon.classList.remove("fa-eye-slash");
        icon.classList.add("fa-eye");
      }

      this.$root.$emit('map-visible-mapping', item);
    },
    removeItem(item) {
      this.mappingDetails = this.mappingDetails.filter(it => it.id !== item.id);
      console.log("removeItem:", this.mappingDetails);
      console.log("removeItem:", item);
      this.$root.$emit('map-remove-mapping', item);
    },
    removeItemChecked() {
      this.mappingDetailsForDelete.forEach(it => {
        this.selectItem(it);
        this.removeItem(it);
      });
      this.mappingDetailsForDelete = [];
    },
    selectItem(item) {
      console.log(item);
      let itemList = document.querySelector(`#item-mapping-detail-${item.id}`);
      let itemCheck = document.querySelector(`#item-mapping-detail-check-${item.id}`);

      if (itemList == null || itemList == undefined) return;

      if (itemList.classList.contains("item-mapping-detail-select")) {
        itemList.classList.remove("item-mapping-detail-select");
        itemCheck.checked = false;
        this.mappingDetailsForDelete = this.mappingDetailsForDelete.filter(it => {
          return it.id != item.id
        });
        this.$root.$emit("map-deselect-mapping", item);
      } else {
        itemList.classList.add("item-mapping-detail-select");
        itemCheck.checked = true;
        this.mappingDetailsForDelete.push(item);
        this.$root.$emit("map-select-mapping", item);
      }
    },
    dialogItem(item) {
      const self = this;
      self.$swal
          .fire({
            title: 'Detalle de Mapeo',
            showCancelButton: true,
            confirmButtonText: 'Aceptar',
            cancelButtonText: 'Cancelar ',
            cancelButtonAriaLabel: 'Cerrar',
            cancelButtonColor: '#d33',
            confirmButtonColor: '#00a63b',
            html:
                `<input id="name" class="swal2-input" style="padding: 8px" type="text" autofocus placeholder="Nombre" value="${item.nombre}">` +
                `<textarea id="note" class="swal2-input" placeholder="Notas" rows="8" style="padding: 8px">${item.nota}</textarea>`,

            preConfirm: function () {
              return new Promise(function (resolve) {
                let name = document.getElementById('name');
                let note = document.getElementById('note');
                self.mappingDetails.forEach(it => {
                  if (it.id == item.id) {
                    it.nombre = name.value;
                    it.nota = note.value;
                    self.$root.$emit("map-set-mapping-detail", it);
                    return;
                  }
                })
                self.$swal.close()
              })
            },
          });
    },
    newItem(idc_figure) {
      let mappingDetail = {
        "id": uuidv4(),
        "id_mapeo": 0,
        "idc_figura": idc_figure,
        "nombre": "",
        "nota": "",
        "lstMapeo_fotos": [],
        "lstMapeo_puntos": []
      }
      switch (idc_figure) {
        case 1: {
          this.$root.$emit("map-add-area", mappingDetail);
          break;
        }
        case 2: {
          this.$root.$emit("map-add-point", mappingDetail);
          break;
        }
        case 3: {
          this.$root.$emit("map-add-line", mappingDetail);
          break;
        }
      }
    },
    addItem(item) {
      console.log("additem:", item)
      this.mappingDetails.push(item);
    },
    loadCSV(event) {
      const self = this;
      let csv = event.target.files[0];
      const reader = new FileReader();

      reader.onload = function (event) {
        const text = event.target.result;
        const data = Utils.csvToArray(text);
        data.forEach(it => {
          let mappingDetail = {
            "id": uuidv4(),
            "id_mapeo": 0,
            "idc_figura": 2,
            "nombre": "",
            "nota": "",
            "lstMapeo_fotos": [],
            "lstMapeo_puntos": [{
              "latitud": parseFloat(String(it.latitud).trim()),
              "longitud": parseFloat(String(it.longitud).trim()),
            }]
          }
          self.mappingDetails.push(mappingDetail);
          self.$root.$emit("map-draw-point", mappingDetail);
        });
      };
      reader.readAsText(csv);
    },
    loadKML(event) {
      const self = this;
      let kml = event.target.files[0];
      let formData = new FormData();
      formData.append("file", kml);
      self.$root.$emit("app-show-loading", true);
      axios
          .post(`${config.api.baseURL}/cargarKML`, formData, {
            headers: {"Content-Type": "multipart/form-data"},
          })
          .then(function (response) {
            if (response.data.descripcion === "OK") {
              let details = Utils.fromJSON(response.data.jsonCompleto);
              details.forEach((it) => {
                it.id = uuidv4();
                switch (it.idc_figura) {
                  case 1: {
                    self.$root.$emit("map-draw-area", it);
                    break;
                  }
                  case 2: {
                    self.$root.$emit("map-draw-point", it);
                    break;
                  }
                  case 3: {
                    self.$root.$emit("map-draw-line", it);
                    break;
                  }
                }
                self.mappingDetails.push(it);
              });
            } else {
              self.dialogMessage(response.data.error);
            }
          })
          .catch(err => {
            console.log("MappingABM", err);
          })
          .finally(() => {
            self.$root.$emit("app-show-loading", false);
          });
    },
    loadSHP(event) {
      const self = this;
      let zip = event.target.files[0];
      console.log(zip);
      let formData = new FormData();
      formData.append("file", zip);
      self.$root.$emit("app-show-loading", true);
      axios
          .post(`${config.api.baseURL}/cargarShapefile`, formData, {
            headers: {"Content-Type": "multipart/form-data"},
          })
          .then(function (response) {
            console.log(response);
            if (response.data.descripcion === "OK") {
              let details = Utils.fromJSON(response.data.jsonCompleto);
              details.forEach((it) => {
                it.id = uuidv4();
                switch (it.idc_figura) {
                  case 1: {
                    self.$root.$emit("map-draw-area", it);
                    break;
                  }
                  case 2: {
                    self.$root.$emit("map-draw-point", it);
                    break;
                  }
                  case 3: {
                    self.$root.$emit("map-draw-line", it);
                    break;
                  }
                }
                self.mappingDetails.push(it);
              });
            } else {
              self.dialogMessage(response.data.error);
            }
          })
          .catch(err => {
            console.log("MappingABM", err);
          })
          .finally(() => {
            self.$root.$emit("app-show-loading", false);
          });
    },
    backToMappingList() {
      const self = this;
      this.mappingDetails.forEach(it => {
        self.removeItem(it);
      })

      this.mapping = undefined;
      this.mappingDetails = [];
      this.mappingDetailsForDelete = [];
      this.$root.$emit("navresponsive-show-mapping-list", {});
    },
    dialogMessage(message) {
      const self = this;
      self.$swal.fire({
        icon: 'error',
        title: "Mapeos y coberturas",
        text: message,
        showConfirmButton: false,
        timer: 3000
      })
    },
    exportKmlFile() {
      const self = this;

      if (this.mapping == undefined || this.mapping.uid == undefined || this.mapping.uid == "") {
        self.dialogMessage("Debe guardar primero la cobertura para poder exportar.")
        return;
      }
      this.$root.$emit('app-show-loading', true);
      axios({
        url: `${config.api.baseURL}/obtenerKMLMapeo/${this.mapping.uid}`,
        method: 'GET',
        responseType: 'blob'
      })
          .then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `${this.mapping.nombre}.kml`); //or any other extension
            document.body.appendChild(link);
            link.click();
          })
          .catch(function (err) {
            console.log("CoberturaList: ", err);
          })
          .finally(() => {
            this.$root.$emit('app-show-loading', false);
          });
    },
    showDialogSave() {
      const self = this;
      self.showModalDialogMappingABM = true;
    },
    saveMappping(value) {
      this.showModalDialogMappingABM = false
      if (this.mapping == undefined) {
        this.mapping = {
          "id": 0,
          "id_usuario": LocalStorage.getUserId(),
          "nombre": value.name,
          "descripcion": value.description,
          "fecha": Utils.formatDateTime(new Date(), "yyyy-MM-dd HH:mm:ss"),
          "id_servidor": 0,
          "uid": "",
          "lstMapeo_detalles": this.mappingDetails,
        }
      } else {
        this.mapping.id_servidor = this.mapping.id;
        this.mapping.nombre = value.name;
        this.mapping.descripcion = value.description;
        this.mapping.lstMapeo_detalles = this.mappingDetails;
      }
      this.$root.$emit("map-save-mapping", {mapping: this.mapping});
    },
  },
  created() {
    this.$root.$on("mapping-abm-load-data", this.loadData);
    this.$root.$on("mapping-abm-dialog-item", this.dialogItem);
    this.$root.$on("mapping-abm-add-item", this.addItem);
    this.$root.$on("mapping-abm-back", this.backToMappingList);
  },
  beforeDestroy() {
    this.$root.$off("mapping-abm-load-data", this.loadData);
    this.$root.$off("mapping-abm-dialog-item", this.dialogItem);
    this.$root.$off("mapping-abm-add-item", this.addItem);
    this.$root.$off("mapping-abm-back", this.backToMappingList);
  }
}
</script>

<style scoped>
.content {
  display: flex;
  flex-direction: column;
}

.content-title {
  display: flex;
  flex-direction: column;
  text-transform: uppercase;
  font-size: 14px;
  color: #4a4a4a;
  padding: 15px;
  font-weight: bold;
}

.container-tools {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
  width: 100%;
  grid-gap: 1px;
}

.item-tools {
  padding: 8px;
  cursor: pointer;
  text-align: center;
  background: #34495E;
  padding: 5px;
}

.item-tools-upload {
  opacity: 0.0;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
}

.container-button-confirm {
  display: flex;
  justify-content: space-between;
  padding: 15px;
  column-gap: 10px;
}

.container-list-shape {
  display: flex;
  flex-direction: column;
  height: 85%;
}

.content li {
  padding: 7px 15px 7px 15px !important;
}

ul.no-bullets {
  list-style-type: none;
  padding: 0;
  margin: 0;
}

.item-text {
  font-size: 0.70rem;
}

.item-mapping-detail {
  display: flex;
  color: #4a4a4a;
  font-weight: bold;
  font-size: 12px;
  text-transform: uppercase;
}

.item-mapping-detail-select {
  background-color: #f0c005 !important;
  color: #ffffff
}

.item-mapping-detail-text {
  display: flex;
  flex-direction: revert;
  align-items: center;
}

.item-mapping-detail-text-style {
  color: #4a4a4a;
  font-size: 12px;
  margin: 0px 15px 0px 15px;
}

.button.is-primary {
  background-color: #00a63b !important;
  width: 50%;
  color: #fff;
  padding-right: 5px;
  padding-left: 5px;
  margin-bottom: 10px;
  font-size: 0.70rem;
}

.button.is-danger {
  background-color: #dc3545 !important;
  width: 50%;
  color: #fff;
  padding-right: 5px;
  padding-left: 5px;
  margin-bottom: 10px;
  font-size: 0.70rem;
}

.button.is-link {
  background-color: #F4C811 !important;
  width: 50%;
  color: #fff;
  padding-right: 5px;
  padding-left: 5px;
  margin-bottom: 10px;
  font-size: 0.70rem;
}

.button.is-primary {
  background-color: #23841f !important;
  border-color: transparent;
  color: #fff;
}

.button.is-primary:hover, .button.is-primary.is-hovered {
  background-color: #23841f !important;
  border-color: transparent;
  color: #fff;
}

.dialog-mapping-abm {
  z-index: 10001;
}
</style>